var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "permission",
          rawName: "v-permission",
          value: _vm.PERMISSIONS.VIEW_PORTFOLIO,
          expression: "PERMISSIONS.VIEW_PORTFOLIO",
        },
      ],
      staticClass: "animated fadeIn",
    },
    [
      _c(
        "b-tabs",
        {
          staticClass: "body-bg-color",
          staticStyle: {
            "border-left": "0",
            "border-right": "0",
            "border-top": "0",
          },
        },
        [
          _c(
            "b-tab",
            {
              ref: "overview",
              staticClass: "body-bg-color overview-chart",
              staticStyle: {
                "border-left": "0",
                "border-right": "0",
                "border-top": "0",
              },
              attrs: { active: "" },
              on: {
                click: function ($event) {
                  return _vm.routeTo()
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [_vm._v(_vm._s(_vm.$t("message.overview")))]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("table", [
                _c("tr", [
                  _c("td", { staticClass: "heading" }, [
                    _vm._v(_vm._s(_vm.$t("message.license_name")) + ":"),
                  ]),
                  _c("td", [_vm._v(_vm._s(_vm.license.name))]),
                ]),
                _c("tr", [
                  _c("td", { staticClass: "heading" }, [
                    _vm._v(_vm._s(_vm.$t("message.spdx_license_id")) + ":"),
                  ]),
                  _c("td", [_vm._v(_vm._s(_vm.license.licenseId))]),
                ]),
                _c("tr", [
                  _c("td", { staticClass: "heading" }, [
                    _vm._v(_vm._s(_vm.$t("message.osi_approved")) + ":"),
                  ]),
                  _c("td", [
                    _vm.license.isOsiApproved
                      ? _c("span", [
                          _c("i", { staticClass: "fa fa-check-square-o" }),
                        ])
                      : _c("span", [
                          _c("i", { staticClass: "fa fa-square-o" }),
                        ]),
                  ]),
                ]),
                _c("tr", [
                  _c("td", { staticClass: "heading" }, [
                    _vm._v(_vm._s(_vm.$t("message.fsf_libre")) + ":"),
                  ]),
                  _c("td", [
                    _vm.license.isFsfLibre
                      ? _c("span", [
                          _c("i", { staticClass: "fa fa-check-square-o" }),
                        ])
                      : _c("span", [
                          _c("i", { staticClass: "fa fa-square-o" }),
                        ]),
                  ]),
                ]),
                _c("tr", [
                  _c("td", { staticClass: "heading" }, [
                    _vm._v(_vm._s(_vm.$t("message.deprecated")) + ":"),
                  ]),
                  _c("td", [
                    _vm.license.isDeprecatedLicenseId
                      ? _c("span", [
                          _c("i", { staticClass: "fa fa-check-square-o" }),
                        ])
                      : _c("span", [
                          _c("i", { staticClass: "fa fa-square-o" }),
                        ]),
                  ]),
                ]),
                _c("tr", [
                  _c("td", { staticClass: "heading" }, [
                    _vm._v(_vm._s(_vm.$t("message.custom_license")) + ":"),
                  ]),
                  _c("td", [
                    _vm.license.isCustomLicense
                      ? _c("span", [
                          _c("i", { staticClass: "fa fa-check-square-o" }),
                        ])
                      : _c("span", [
                          _c("i", { staticClass: "fa fa-square-o" }),
                        ]),
                  ]),
                ]),
                _c("tr", [
                  _c("td", { staticClass: "heading" }, [
                    _vm._v(_vm._s(_vm.$t("message.comments")) + ":"),
                  ]),
                  _c("td", [_vm._v(_vm._s(_vm.license.licenseComments))]),
                ]),
                _c("tr", [
                  _c("td"),
                  _c("td", [
                    _vm.license.isOsiApproved
                      ? _c("img", {
                          attrs: {
                            src: require("@/assets/img//osi-logo.svg"),
                            alt: "OSI logo",
                            width: "80",
                          },
                        })
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]
          ),
          _c(
            "b-tab",
            {
              ref: "licensetext",
              on: {
                click: function ($event) {
                  return _vm.routeTo("licenseText")
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [_vm._v(_vm._s(_vm.$t("message.license_text")))]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "div",
                { staticClass: "licenseText formattedLicenseContent" },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.license.licenseText) + "\n      "
                  ),
                ]
              ),
            ]
          ),
          _c(
            "b-tab",
            {
              ref: "template",
              on: {
                click: function ($event) {
                  return _vm.routeTo("template")
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [_vm._v(_vm._s(_vm.$t("message.template")))]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "div",
                { staticClass: "templateText formattedLicenseContent" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.license.standardLicenseTemplate) +
                      "\n      "
                  ),
                ]
              ),
            ]
          ),
          _c(
            "b-tab",
            {
              ref: "header",
              on: {
                click: function ($event) {
                  return _vm.routeTo("header")
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [_vm._v(_vm._s(_vm.$t("message.source_header")))]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("div", { staticClass: "headerText formattedLicenseContent" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.license.standardLicenseHeader) +
                    "\n      "
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm.license.isCustomLicense
        ? _c(
            "b-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: _vm.PERMISSIONS.SYSTEM_CONFIGURATION,
                  expression: "PERMISSIONS.SYSTEM_CONFIGURATION",
                },
              ],
              attrs: { variant: "outline-danger" },
              on: { click: _vm.removeCustomLicense },
            },
            [_vm._v(_vm._s(_vm.$t("message.delete")))]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }